import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'number',})
export class NumberPipe implements PipeTransform {
  // 
  transform1(value: number | string, digitsInfo: string = '1.0-2'): string {
    if (value === null || value === undefined) return '';
    
    // Ensure the value is a number
    const num = Number(value);
    if (isNaN(num)) return value.toString();
    
    // Parse the digitsInfo to handle decimal places
    const [minInt, minFrac, maxFrac] = digitsInfo.split('-').map(part => parseInt(part));

    // Determine the number of decimals to keep based on digitsInfo
    let decimals = (isNaN(minFrac) ? 0 : minFrac);

    // Adjust decimal places if the `maxFrac` is specified
    if (!isNaN(maxFrac)) {
      decimals = Math.min(decimals, maxFrac);
    }

    // Format the number based on decimal requirement
    const fixedValue = num.toFixed(decimals);
    const parts = fixedValue.split('.');
    let integerPart = parts[0];
    const decimalPart = parts[1] || '';

    // Indian Number Format: 1,00,000 for example
    let lastThree = integerPart.substring(integerPart.length - 3);
    let otherNumbers = integerPart.substring(0, integerPart.length - 3);
    if (otherNumbers !== '') {
      lastThree = ',' + lastThree;
    }
    const formattedIntegerPart = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;

    // Return the formatted number with the correct number of decimals
    if (decimals > 0) {
      return formattedIntegerPart + '.' + decimalPart;
    } else {
      return formattedIntegerPart;  // No decimal part
    }
  }

  transform(value: number | string, digitsInfo: string = '1.0-2'): string {
  if (value === null || value === undefined) return '';

  const num = Number(value);
  if (isNaN(num)) return value.toString();

  // Handle negative numbers
  const isNegative = num < 0;
  const absoluteNum = Math.abs(num);

  const [minInt, minFrac, maxFrac] = digitsInfo
    .split('-')
    .map(part => parseInt(part));

  let decimals = isNaN(minFrac) ? 0 : minFrac;

  if (!isNaN(maxFrac)) {
    decimals = Math.min(decimals, maxFrac);
  }

  const fixedValue = absoluteNum.toFixed(decimals);
  const parts = fixedValue.split('.');
  let integerPart = parts[0];
  const decimalPart = parts[1] || '';

  // Indian Number Format
  let lastThree = integerPart.substring(integerPart.length - 3);
  let otherNumbers = integerPart.substring(0, integerPart.length - 3);

  if (otherNumbers !== '') {
    lastThree = ',' + lastThree;
  }

  const formattedIntegerPart =
    otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree;

  const result =
    decimals > 0
      ? `${formattedIntegerPart}.${decimalPart}`
      : formattedIntegerPart;

  return isNegative ? `-${result}` : result;
}
}
